export default function ImageDetailsModal({
  show,
  imageUrl,
  title = "Image details",
  subtitle = "",
  onClose,
}) {
  if (!show) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" style={{ background: "rgba(7, 16, 35, 0.62)" }}>
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
            <div
              className="modal-header border-0 px-4 py-3"
              style={{ background: "linear-gradient(135deg, #ffffff 0%, #f7fafc 100%)" }}
            >
              <div className="pe-3">
                <h5 className="modal-title mb-1 fw-semibold">{title}</h5>
                {subtitle && <small className="text-secondary">{subtitle}</small>}
              </div>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            <div className="modal-body p-4" style={{ background: "linear-gradient(180deg, #f8fbff 0%, #f3f6fb 100%)" }}>
              {imageUrl ? (
                <div
                  className="rounded-4 border bg-white p-3 shadow-sm"
                  style={{ borderColor: "#e7edf7" }}
                >
                  <img
                    src={imageUrl}
                    alt={title}
                    className="img-fluid rounded-3 w-100"
                    style={{ maxHeight: "65vh", objectFit: "contain", background: "#f8fafc" }}
                  />
                </div>
              ) : (
                <div className="text-secondary">No image available.</div>
              )}
            </div>

            <div className="modal-footer border-0 px-4 py-3" style={{ background: "#ffffff" }}>
              <button type="button" className="btn btn-outline-secondary rounded-pill px-3" onClick={onClose}>
                Close
              </button>
              {imageUrl && (
                <a
                  href={imageUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-primary rounded-pill px-3"
                >
                  <i className="bi bi-box-arrow-up-right me-1"></i>
                  Open in new tab
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" onClick={onClose}></div>
    </>
  );
}
